import { render, staticRenderFns } from "./KoulutusSeteliHowTo.vue?vue&type=template&id=57d9fd58&"
import script from "./KoulutusSeteliHowTo.vue?vue&type=script&lang=js&"
export * from "./KoulutusSeteliHowTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports